import { render, staticRenderFns } from "./CommentTool.vue?vue&type=template&id=a4c2a76a&scoped=true&"
import script from "./CommentTool.vue?vue&type=script&lang=ts&"
export * from "./CommentTool.vue?vue&type=script&lang=ts&"
import style0 from "./CommentTool.vue?vue&type=style&index=0&id=a4c2a76a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c2a76a",
  null
  
)

export default component.exports